import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { apiURL, commonHeadersWeb, mediaURL } from 'src/consumer/services'
import BadgeModalComponent, {
    ActiveBadgeComponentInStrip,
    BadgeDetailComponent,
    EarnYourFirstBadgeComponent,
    HighlightedBadgeComponent,
} from './LeaderboardPageComponents'
import {
    AllEarnedRewardsContainer,
    AwardsRow,
    BadgeInformationDrawer,
    YourBadgesSectionContainer,
    YourStatsTableItemHeading,
} from './LeaderboardPageStyles'

import astronautImage from 'src/assets/astronaut_image.png'
import blueDiscImage from 'src/assets/blue_disc_image.png'
import diskInActive from 'src/assets/disc_inactive.png'
import padlockIcon from 'src/assets/padlock.png'
import purpleDiscImage from 'src/assets/purple_disc_image.png'

export default function YourBadges() {
  const [userBadges, setUserBadges] = useState(null)
  const [modifiedUserBadgesData, setModifiedUserBadgesData] = useState([])
  const [hightlightsData, setHighlightsData] = useState([])
  const token = localStorage?.getItem('token')
  const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } =
    useContext(UnsecureSetupContext)
  const [isBadgeDetailOpen, setIsBadgeDetailOpen] = useState({ state: false, data: {} })

  let badgeInformationShowingMethod
  if (unSecureSetupData?.clientType === 'mobileBrowser') {
    badgeInformationShowingMethod = 'drawer'
  } else {
    badgeInformationShowingMethod = 'modal'
  }

  const getColor = (num) => {
    if (num % 2) {
      return 'linear-gradient(145deg, #6A0DCE 0%, #BA89EF 100%)'
    } else {
      return 'linear-gradient(145deg, #3AD7FA 0%, #5174FC 100%)'
    }
  }
  const getDisc = (num) => {
    if (num % 2) {
      return blueDiscImage
    } else {
      return purpleDiscImage
    }
  }

  const getBadges = async () => {
    try {
      const response = await axios.get(`${apiURL}/api/secure/user/badges`, {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersWeb,
          'ef-user-country-code': localStorage.getItem('countryCode'),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      })
      setUserBadges(response?.data)
      return response?.data
    } catch (error) {
      console.log(error)
      return error
    }
  }

  const getHighlights = (allCategoryData) => {
    const allHighlights = []

    allCategoryData?.forEach((item) => {
      let categoryName = item?.category
      let categoryMax

      item?.items?.forEach((categoryItem) => {
        if (categoryItem?.currentCount >= categoryItem?.maxCount) {
          categoryMax = categoryItem
        }
      })

      if (Boolean(categoryMax)) {
        allHighlights?.push({ name: categoryName, highlight: categoryMax })
      }
    })

    return allHighlights
  }

  useEffect(() => {
    getBadges()
  }, [])

  useEffect(() => {
    if (Boolean(userBadges)) {
      let modifiedData = []

      // Loop through each item in the original data
      userBadges?.forEach((item) => {
        // Loop through each category of the item
        item?.categories?.forEach((category) => {
          // Check if the category title already exists in the modified data
          const existingCategory = modifiedData?.find((data) => data?.category === category?.title)
          if (existingCategory) {
            // If the category already exists, push the item into its items array
            existingCategory?.items?.push(item)
          } else {
            // If the category doesn't exist, create a new object and add it to the modified data array
            modifiedData?.push({
              category: category?.title,
              items: [item],
            })
          }
        })
      })

      setModifiedUserBadgesData(modifiedData)
      setHighlightsData(getHighlights(modifiedData))
    }
  }, [userBadges])

  return (
    <>
      {Boolean(userBadges) ? (
        <YourBadgesSectionContainer>
          <YourStatsTableItemHeading>Awards Gallery</YourStatsTableItemHeading>

          {hightlightsData?.length > 0 ? (
            <>
              <AllEarnedRewardsContainer>
                {hightlightsData?.map((highlightItem, index) => {
                  return (
                    <HighlightedBadgeComponent
                      title={highlightItem?.highlight?.title}
                      category={highlightItem?.name}
                      colorString={getColor(index)}
                      discImage={getDisc(index)}
                      icon={astronautImage}
                      description={highlightItem?.highlight?.description}
                      unSecureSetupData={unSecureSetupData}
                      setIsBadgeDetailOpen={setIsBadgeDetailOpen}
                      data={highlightItem?.highlight}
                      key={index}
                    />
                  )
                })}
              </AllEarnedRewardsContainer>
            </>
          ) : (
            <AllEarnedRewardsContainer>
              <EarnYourFirstBadgeComponent />
            </AllEarnedRewardsContainer>
          )}

          {modifiedUserBadgesData?.map((item, index) => {
            return (
              <div key={index}>
                <YourStatsTableItemHeading key={index}>
                  To be earned for {item?.category}
                </YourStatsTableItemHeading>
                <AwardsRow>
                  {item?.items?.map((itemData, indexItem) => {
                    if (itemData?.enabled) {
                      let earned
                      let icon
                      let colorString
                      let discIcon
                      if (parseInt(itemData?.currentCount) >= parseInt(itemData?.maxCount)) {
                        earned = true
                        icon = itemData?.iconId ? `${mediaURL}${itemData?.iconId}` : astronautImage
                        colorString = getColor(indexItem)
                        discIcon = getDisc(indexItem)
                      } else {
                        earned = false
                        icon = padlockIcon
                        colorString =
                          'linear-gradient(145deg, rgba(74, 75, 86, 1) 0%, rgba(139, 141, 150, 1) 100%)'
                        discIcon = diskInActive
                      }
                      return (
                        <ActiveBadgeComponentInStrip
                          title={itemData?.title}
                          subtitle={itemData?.description}
                          currentCount={itemData?.currentCount}
                          maxCount={itemData?.maxCount}
                          earned={earned}
                          icon={icon}
                          colorString={colorString}
                          discIcon={discIcon}
                          key={indexItem}
                        />
                      )
                    }
                  })}
                </AwardsRow>
              </div>
            )
          })}

          {badgeInformationShowingMethod === 'drawer' && (
            <BadgeInformationDrawer
              className="drawer"
              anchor="bottom"
              open={isBadgeDetailOpen?.['state']}
              transitionDuration={{ enter: 600, exit: 300 }}
            >
              <BadgeDetailComponent
                isBadgeDetailOpen={isBadgeDetailOpen}
                setIsBadgeDetailOpen={setIsBadgeDetailOpen}
              />
            </BadgeInformationDrawer>
          )}

          {badgeInformationShowingMethod === 'modal' && (
            <BadgeModalComponent
              isBadgeDetailOpen={isBadgeDetailOpen}
              setIsBadgeDetailOpen={setIsBadgeDetailOpen}
            >
              <BadgeDetailComponent
                isBadgeDetailOpen={isBadgeDetailOpen}
                setIsBadgeDetailOpen={setIsBadgeDetailOpen}
              />
            </BadgeModalComponent>
          )}
        </YourBadgesSectionContainer>
      ) : (
        <Spinner animation="border" variant="light" size="md" />
      )}
    </>
  )
}
